import {Injectable} from '@angular/core';
import sdk from '@sp400/sdk'
import {Subject} from "rxjs";
import {CacheService} from "./cache.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loggedInStatus: boolean = false;
  loggedInObservable: Subject<boolean> = new Subject<boolean>();

  constructor() {
  }

  login(userId: string, password: string): Promise<any> {
    return sdk.set('authentication.login', {
      loginID: userId,
      password: password
    });
  }

  logout(): Promise<any> {
    return sdk.set('authentication.logout', null);
  }

  forgotPassword(email: string): Promise<any> {
    return sdk.set('authentication.forgotPassword', {
      loginID: email
    });
  }

  setIsLogged(value: boolean) {
    this.loggedInStatus = value;
    this.loggedInObservable.next(this.loggedInStatus);
  }

  hasSession(): boolean {
    return this.loggedInStatus;
  }
}
